"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reflux = _interopRequireDefault(require("reflux"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _rcProgress = require("rc-progress");

var _BuildConstants = require("../../../utils/BuildConstants");

var _strings = require("./strings");

var _NavigationManagerCordova = _interopRequireDefault(require("../../../common/NavigationManagerCordova"));

var _UserInfo = _interopRequireDefault(require("./UserInfo.scss"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _ContentStore = _interopRequireDefault(require("../../../KESI2/Stores/ContentStore"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _Button = _interopRequireDefault(require("../Button"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _MuiAlertHelper = require("../../../helpers/MuiAlertHelper");

var _Image = _interopRequireDefault(require("../Image/Image"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _UserProfile = _interopRequireDefault(require("./UserProfile"));

var _NullComponent = _interopRequireDefault(require("../NullComponent/NullComponent.js"));

var _DrupalRubric = _interopRequireDefault(require("../DrupalTiles/DrupalRubric.scss"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _PreconditionActionExecutioner = require("../../../utils/PreconditionActionExecutioner");

var _PlayArrow = _interopRequireDefault(require("@material-ui/icons/PlayArrow"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Constants = require("../../constants/Constants");

var _SettingsCordova = _interopRequireDefault(require("../SettingsCordova/SettingsCordova"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var UserInfo = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(UserInfo, _DataStoreComponent);

  var _super = _createSuper(UserInfo);

  function UserInfo(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, UserInfo);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onListitemClick", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(path, content, forceClick) {
        var failedPrecondition, continueOnFail, joinedPath;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (forceClick) {
                  _context.next = 6;
                  break;
                }

                failedPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.openPrecondition);
                continueOnFail = (0, _PreconditionChecker.continueIfPreconditionFailed)(failedPrecondition);

                if (!failedPrecondition) {
                  _context.next = 6;
                  break;
                }

                (0, _PreconditionActionExecutioner.preconditionAction)(failedPrecondition, continueOnFail ? _this.onListitemClick(path, content, continueOnFail) : function () {});
                return _context.abrupt("return");

              case 6:
                _context.next = 8;
                return path.join('!');

              case 8:
                joinedPath = _context.sent;
                return _context.abrupt("return", _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId, "!").concat(joinedPath)));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goUp", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _TimeoutHelper.timeout)();

            case 2:
              return _context2.abrupt("return", _NavigationManagerCordova["default"].goTo(_config["default"].cordovaStartUrl(), null, true));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPdf", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var template,
          url,
          token,
          result,
          _args3 = arguments;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              template = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
              console.log('getPDF');

              if (!_config["default"].isDemo) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return", (0, _MuiAlertHelper.showWideAlertHtml)('Diese Funktion ist in dieser Demo nicht verfügbar. Hier könnte ein an Ihre Wünsche angepasstes Zertifikat hinterlegt werden.', 'Funktion nicht verfügbar'));

            case 4:
              _context3.prev = 4;
              url = _BuildConstants.PDF_HOST + '/' + _config["default"].certificatePdfCreationUrl + "".concat(template ? "?template=".concat(template) : '');
              console.log('url', url);
              _context3.next = 9;
              return _RegisterInstance["default"].getAccessToken('eCloud:read');

            case 9:
              token = _context3.sent;
              _context3.next = 12;
              return (0, _HttpRequest.httpGet)(url, {}, {}, 15000, 2, 'Bearer ' + token, null, null, true);

            case 12:
              result = _context3.sent;

              if (!(result && result.data && result.data.url)) {
                _context3.next = 17;
                break;
              }

              if (_DeviceInfoHelper["default"].isBrowser()) {
                window.location = _BuildConstants.PDF_HOST + result.data.url;
              } else {
                window.open(_BuildConstants.PDF_HOST + result.data.url, '_system');
              }

              _context3.next = 18;
              break;

            case 17:
              throw new Error('no url in pdf answer');

            case 18:
              _context3.next = 23;
              break;

            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3["catch"](4);
              console.error('ERROR', 'UserInfo.getPdf', _context3.t0);

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 20]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTopLevelContents", function () {
      var topLevelIds = [];
      var topLevelContentType = null;

      if (_config["default"].usesCourses) {
        (0, _keys["default"])(_this.state.content).forEach(function (id) {
          if (_this.state.content[id].type === _Constants.CONTENT_TYPES.COURSE) {
            topLevelIds.push(id);
            topLevelContentType = _Constants.CONTENT_TYPES.COURSE;
          }
        });
      } else if (!_config["default"].usesCourses && !_config["default"].showOnlyLectures) {
        (0, _keys["default"])(_this.state.content).forEach(function (id) {
          if (_this.state.content[id].type === _Constants.CONTENT_TYPES.SPOC) {
            topLevelIds.push(id);
            topLevelContentType = _Constants.CONTENT_TYPES.SPOC;
          }
        });
      } else if (!_config["default"].usesCourses && _config["default"].showOnlyLectures) {
        (0, _keys["default"])(_this.state.content).forEach(function (id) {
          if (_this.state.content[id].type === _Constants.CONTENT_TYPES.LECTURE) {
            topLevelIds.push(id);
            topLevelContentType = _Constants.CONTENT_TYPES.LECTURE;
          }
        });
      }

      _this.setState({
        topLevelIds: topLevelIds,
        topLevelContentType: topLevelContentType
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sortContents", function (contents, type) {
      if (_config["default"].sortAlphabetically) {
        return contents.sort(function (content1, content2) {
          if (content1.title < content2.title) {
            return -1;
          }

          if (content1.title > content2.title) {
            return 1;
          }

          return 0;
        });
      }

      if (_config["default"].sortById) {
        return contents.sort(function (content1, content2) {
          return content1.id - content2.id;
        });
      }

      if (_config["default"].sortByOrderField && (type === _Constants.CONTENT_TYPES.SPOC || type === _Constants.CONTENT_TYPES.COURSE)) {
        return contents.sort(function (content1, content2) {
          if ((content1.order || content1.order === 0) && (content2.order || content2.order === 0)) {
            if (content1.order < content2.order) {
              return -1;
            }

            if (content1.order > content2.order) {
              return 1;
            }

            return 0;
          } else {
            // Don't bring up id sorting here!
            // This piece of code is used for lecture-in-spoc sorting, too and we want to keep the author's order there
            return 0;
          }
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openContent", function (id, type, force) {
      var content = _this.state.content[id];

      if (content.openPrecondition && !force) {
        var failedPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.openPrecondition);
        var continueOnFail = (0, _PreconditionChecker.continueIfPreconditionFailed)(failedPrecondition);
        console.log('openContent', continueOnFail);

        if (failedPrecondition) {
          (0, _PreconditionActionExecutioner.preconditionAction)(failedPrecondition, continueOnFail ? _this.openContent(id, type, true) : function () {});
          return;
        }
      }

      console.log('openContent2', content);

      if (type === _Constants.CONTENT_TYPES.COURSE) {
        if (_this.state.openCourse === id) {
          _this.setState({
            openCourse: null,
            openSpoc: null
          });
        } else {
          _this.setState({
            openCourse: id,
            openSpoc: null
          });
        }
      }

      if (type === _Constants.CONTENT_TYPES.SPOC) {
        if (_this.state.openSpoc === id) {
          _this.setState({
            openSpoc: null
          });
        } else {
          _this.setState({
            openSpoc: id
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderUserData", function () {
      return /*#__PURE__*/_react["default"].createElement(_UserProfile["default"], null);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderBookedCourses", function () {
      return /*#__PURE__*/_react["default"].createElement(_NullComponent["default"], {
        contentPathArray: ['UserInfo'],
        showOnlyMyBookings: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderCerts", function () {
      return _config["default"].certificates.map(function (cert) {
        var dataStoreValue = _DataStore["default"].getElementByPathImmediately(cert.path);

        if (dataStoreValue) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _DrupalRubric["default"].certContainer
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _UserInfo["default"].userTextSmall,
            dangerouslySetInnerHTML: {
              __html: (0, _strings.getString)('USER_INFO_CERT_DONE', [cert.title])
            }
          }), /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              margin: '20px 0'
            }
          }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            onClick: function onClick() {
              _this.getPdf(cert.template);
            }
          }, (0, _strings.getString)('DOWNLOAD_CERTIFICATE_WITH_NAME', [cert.title]))));
        }
      });
    });
    _this.state = {
      showSpinner: false,
      allContentDone: false,
      openSpoc: null,
      openCourse: null,
      topLevelIds: [],
      topLevelContentType: null,
      filePath: _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder()
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(UserInfo.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.FEATURES]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(UserInfo.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'navbar', 'button']
    }, {
      store: _ContentStore["default"],
      keys: ['content']
    }]);
    return _this;
  }
  /*
  componentWillMount () {
    this.props.setTitle(getString('MY_PROGRESS'))
    this.props.setBackButtonFunc(this.goUp)
  }
  */


  (0, _createClass2["default"])(UserInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _target$userInfoTitle,
          _this2 = this;

      this.props.setTitle((_target$userInfoTitle = _config["default"].userInfoTitle) !== null && _target$userInfoTitle !== void 0 ? _target$userInfoTitle : (0, _strings.getString)('MY_PROGRESS'));

      _NavigationManagerCordova["default"].setNavbarBackgroundColor(null);

      this.props.setBackButtonFunc(this.goUp);
      setTimeout(function () {
        _this2.getTopLevelContents();
      }, 100);
    }
  }, {
    key: "renderLecture",
    // getPercentageForContent = (contentId) => {
    //   if (this.percentages[contentId]) {
    //     return this.percentages[contentId]
    //   }
    //
    //   const content = this.state.content[contentId]
    //   if (content.type === CONTENT_TYPES.COURSE) {
    //     let coursePercentage = 0
    //     let childCount = 0
    //     if (content.spocIds && content.spocIds.length > 0) {
    //       content.spocIds.forEach(spocId => {
    //         const spocContent = this.state.content[spocId]
    //         const failingPrecondition = getFailingPrecondition(spocContent.showPrecondition)
    //         if (!failingPrecondition) {
    //           coursePercentage += this.getPercentageForContent(spocId)
    //           childCount ++
    //         }
    //       })
    //     }
    //     if (content.lectureIds && content.lectureIds.length > 0) {
    //       content.lectureIds.forEach(lectureId => {
    //         const lectureContent = this.state.content[lectureId]
    //         const failingPrecondition = getFailingPrecondition(lectureContent.showPrecondition)
    //         if (!failingPrecondition) {
    //           coursePercentage += this.getPercentageForContent(lectureId)
    //           childCount ++
    //         }
    //       })
    //     }
    //     this.percentages[contentId] = coursePercentage / childCount > 100 ? 100 : Math.ceil(coursePercentage / childCount)
    //     return coursePercentage / childCount > 100 ? 100 : Math.ceil(coursePercentage / childCount)
    //   }
    //   else if (content.type === CONTENT_TYPES.SPOC) {
    //     let spocPercentage = 0
    //     let childCount = 0
    //     if (content.lectureIds && content.lectureIds.length > 0) {
    //       content.lectureIds.forEach(lectureId => {
    //         const lectureContent = this.state.content[lectureId]
    //         const failingPrecondition = getFailingPrecondition(lectureContent.showPrecondition)
    //         if (!failingPrecondition) {
    //           spocPercentage += this.getPercentageForContent(lectureId)
    //           childCount ++
    //         }
    //       })
    //       this.percentages[contentId] = spocPercentage / childCount > 100 ? 100 : Math.ceil(spocPercentage / childCount)
    //       return spocPercentage / childCount > 100 ? 100 : Math.ceil(spocPercentage / childCount)
    //     }
    //   }
    //   else if (content.type === CONTENT_TYPES.LECTURE) {
    //     let lecturePercentage = 0
    //     let childCount = 0
    //     if (content.nuggetIds && content.nuggetIds.length > 0) {
    //       content.nuggetIds.forEach(nuggetId => {
    //         const lectureContent = this.state.content[nuggetId]
    //         const failingPrecondition = getFailingPrecondition(lectureContent.showPrecondition)
    //         if (!failingPrecondition) {
    //           lecturePercentage += this.getPercentageForContent(nuggetId)
    //           childCount++
    //         }
    //       })
    //       this.percentages[contentId] = lecturePercentage / childCount > 100 ? 100 : Math.ceil(lecturePercentage / childCount)
    //       return lecturePercentage / childCount > 100 ? 100 : Math.ceil(lecturePercentage / childCount)
    //     }
    //   }
    //   else {
    //     const nuggetPercent = KESI2Helper.checkIfContentRead(content) ? 100 : 0
    //     this.percentages[contentId] = nuggetPercent
    //     return nuggetPercent
    //   }
    // }
    value: function renderLecture(content) {
      var _this3 = this;

      var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var isNotMandatory = _KESI2Helper["default"].checkIfNotMandatory(content.id);

      if (isNotMandatory) {
        return null;
      }

      var percentageToShow = 0;

      if (_config["default"].markOpenedLecturesAsCompletelyRead) {
        var additionalData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA);

        if (additionalData && additionalData[content.id]) {
          percentageToShow = additionalData[content.id].read ? 100 : 0;
        }
      } else {
        percentageToShow = _KESI2Helper["default"].getPercentageForContent(content.id) || 0;
      }

      var path = [].concat((0, _toConsumableArray2["default"])(parentPath), [content.id]);
      var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition);

      if (failingPrecondition) {
        return null;
      }

      var backgroundSrc = content.background;
      var iconSrc = content.icon;

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        backgroundSrc = "".concat(this.state.filePath).concat(content.background);
        iconSrc = "".concat(this.state.filePath).concat(content.icon);
      }

      var colorToUse = _cssConstants["default"].colors.tileFontColor === '#FFFFFF' || _cssConstants["default"].colors.tileFontColor === '#ffffff' ? _cssConstants["default"].colors.buttonBackground : _cssConstants["default"].colors.tileFontColor;
      var isMobile = !_DeviceInfoHelper["default"].isBrowser();
      var greyedOut = content.unhighlightCondition && !(0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition);
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: content.id,
        className: isMobile ? _UserInfo["default"].listItemMobile : _UserInfo["default"].listItem,
        onClick: function onClick() {
          return _this3.onListitemClick(path, content);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].imageColumn
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].iconContainerMobile : _UserInfo["default"].iconContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].percentageContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].iconBackgroundMobile : _UserInfo["default"].iconBackground
      }, content.background ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: backgroundSrc,
        alt: "background image",
        className: "".concat(isMobile ? _UserInfo["default"].backgroundMobile : _UserInfo["default"].background, " ").concat(greyedOut ? _UserInfo["default"].greyedOut : '')
      }) : null, content.icon ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: iconSrc,
        alt: "content icon",
        className: _UserInfo["default"].icon
      }) : null), /*#__PURE__*/_react["default"].createElement(_rcProgress.Circle, {
        className: _UserInfo["default"].percentageCircle,
        percent: "100",
        strokeWidth: "8",
        trailWidth: "0",
        strokeColor: "#d8d8d8"
      }), /*#__PURE__*/_react["default"].createElement(_rcProgress.Circle, {
        className: _UserInfo["default"].percentageCircle,
        percent: percentageToShow,
        strokeWidth: "8",
        trailWidth: "0",
        strokeColor: _cssConstants["default"].colors.buttonBorder
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].column
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].titleMobile : _UserInfo["default"].title
      }, content.title)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].readColumn
      }, percentageToShow >= 100 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].readIconMobile : _UserInfo["default"].readIcon,
        style: {
          border: "3px solid ".concat(colorToUse),
          backgroundColor: colorToUse
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: isMobile ? _UserInfo["default"].innerReadIcon : null,
        src: require('./assets/read_white.svg')
      })) : /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].unreadIconMobile : _UserInfo["default"].unreadIcon,
        style: {
          border: "3px solid ".concat(colorToUse)
        }
      })));
    }
  }, {
    key: "renderCourse",
    value: function renderCourse(content) {
      var _this4 = this;

      var isNotMandatory = _KESI2Helper["default"].checkIfNotMandatory(content.id);

      if (isNotMandatory) {
        return null;
      }

      var lectures = content.lectureIds;
      var spocs = content.spocIds;
      var percentageToShow = _KESI2Helper["default"].getPercentageForContent(content.id) || 0;
      var backgroundSrc = content.background;
      var iconSrc = content.icon;

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        backgroundSrc = "".concat(this.state.filePath).concat(content.background);
        iconSrc = "".concat(this.state.filePath).concat(content.icon);
      }

      var path = [content.id];
      var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition);

      if (failingPrecondition) {
        return null;
      }

      var colorToUse = _cssConstants["default"].colors.tileFontColor === '#FFFFFF' || _cssConstants["default"].colors.tileFontColor === '#ffffff' ? _cssConstants["default"].colors.buttonBackground : _cssConstants["default"].colors.tileFontColor;
      var isMobile = !_DeviceInfoHelper["default"].isBrowser();
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "course_".concat(content.id),
        className: _UserInfo["default"].sublist
      }, /*#__PURE__*/_react["default"].createElement("div", {
        key: content.id,
        className: isMobile ? _UserInfo["default"].courselistItemMobile : _UserInfo["default"].courselistItem
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].spocArrowColumn
      }, /*#__PURE__*/_react["default"].createElement(_PlayArrow["default"], {
        onClick: function onClick() {
          return _this4.openContent(content.id, content.type);
        },
        className: this.state.openCourse === content.id ? _UserInfo["default"].openArrowIcon : _UserInfo["default"].arrowIcon
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].spocImageColumn
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].iconContainerMobile : _UserInfo["default"].iconContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].percentageContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].iconBackgroundMobile : _UserInfo["default"].iconBackground
      }, content.background ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "background image",
        src: backgroundSrc,
        className: isMobile ? _UserInfo["default"].backgroundMobile : _UserInfo["default"].background
      }) : null, content.icon ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "content icon",
        src: iconSrc,
        className: _UserInfo["default"].icon
      }) : null), /*#__PURE__*/_react["default"].createElement(_rcProgress.Circle, {
        className: _UserInfo["default"].percentageCircle,
        percent: "100",
        strokeWidth: "8",
        trailWidth: "0",
        strokeColor: "#d8d8d8"
      }), /*#__PURE__*/_react["default"].createElement(_rcProgress.Circle, {
        className: _UserInfo["default"].percentageCircle,
        percent: percentageToShow,
        strokeWidth: "8",
        trailWidth: "0",
        strokeColor: _cssConstants["default"].colors.buttonBorder
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].spocColumn
      }, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          return _this4.onListitemClick(path, content);
        },
        className: isMobile ? _UserInfo["default"].spocTitleMobile : _UserInfo["default"].spocTitle
      }, content.title.replace('<br/>', ' '))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].readColumn
      }, percentageToShow >= 100 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].readIconMobile : _UserInfo["default"].readIcon,
        style: {
          border: "3px solid ".concat(colorToUse),
          backgroundColor: colorToUse
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: isMobile ? _UserInfo["default"].innerReadIcon : null,
        src: require('./assets/read_white.svg')
      })) : /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].unreadIconMobile : _UserInfo["default"].unreadIcon,
        style: {
          border: "3px solid ".concat(colorToUse)
        }
      }))), this.state.openCourse === content.id && lectures && lectures.length > 0 ? lectures.map(function (lecture) {
        return _this4.renderLecture(_this4.state.content[lecture], [content.id]);
      }) : null, this.state.openCourse === content.id && spocs && spocs.length > 0 ? spocs.map(function (spoc) {
        return _this4.renderSpoc(_this4.state.content[spoc], [content.id]);
      }) : null);
    }
  }, {
    key: "renderSpoc",
    value: function renderSpoc(content) {
      var _this5 = this;

      var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var isNotMandatory = _KESI2Helper["default"].checkIfNotMandatory(content.id);

      if (isNotMandatory) {
        return null;
      }

      var lectures = content.lectureIds;
      var percentageToShow = _KESI2Helper["default"].getPercentageForContent(content.id) || 0;
      var path = [].concat((0, _toConsumableArray2["default"])(parentPath), [content.id]);
      if (content.hasOwnProperty('parentCourseId') && content.parentCourseId) path.unshift(content.parentCourseId);
      var backgroundSrc = content.background;
      var iconSrc = content.icon;

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        backgroundSrc = "".concat(this.state.filePath).concat(content.background);
        iconSrc = "".concat(this.state.filePath).concat(content.icon);
      }

      var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition);

      if (failingPrecondition) {
        return null;
      }

      var colorToUse = _cssConstants["default"].colors.tileFontColor === '#FFFFFF' || _cssConstants["default"].colors.tileFontColor === '#ffffff' ? _cssConstants["default"].colors.buttonBackground : _cssConstants["default"].colors.tileFontColor;
      var isMobile = !_DeviceInfoHelper["default"].isBrowser();
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "spoc_".concat(content.id),
        className: _UserInfo["default"].sublist
      }, /*#__PURE__*/_react["default"].createElement("div", {
        key: content.id,
        className: isMobile ? _UserInfo["default"].spoclistItemMobile : _UserInfo["default"].spoclistItem
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].spocArrowColumn
      }, /*#__PURE__*/_react["default"].createElement(_PlayArrow["default"], {
        onClick: function onClick() {
          return _this5.openContent(content.id, content.type);
        },
        className: this.state.openSpoc === content.id ? _UserInfo["default"].openArrowIcon : _UserInfo["default"].arrowIcon
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].spocImageColumn
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].iconContainerMobile : _UserInfo["default"].iconContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].percentageContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].iconBackgroundMobile : _UserInfo["default"].iconBackground
      }, content.background ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "background image",
        src: backgroundSrc,
        className: isMobile ? _UserInfo["default"].backgroundMobile : _UserInfo["default"].background
      }) : null, content.icon ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "content icon",
        src: iconSrc,
        className: _UserInfo["default"].icon
      }) : null), /*#__PURE__*/_react["default"].createElement(_rcProgress.Circle, {
        className: _UserInfo["default"].percentageCircle,
        percent: "100",
        strokeWidth: "8",
        trailWidth: "0",
        strokeColor: "#d8d8d8"
      }), /*#__PURE__*/_react["default"].createElement(_rcProgress.Circle, {
        className: _UserInfo["default"].percentageCircle,
        percent: percentageToShow,
        strokeWidth: "8",
        trailWidth: "0",
        strokeColor: _cssConstants["default"].colors.buttonBorder
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].spocColumn
      }, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          return _this5.onListitemClick(path, content);
        },
        className: isMobile ? _UserInfo["default"].spocTitleMobile : _UserInfo["default"].spocTitle
      }, content.title.replace('<br/>', ' '))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].readColumn
      }, percentageToShow >= 100 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].readIconMobile : _UserInfo["default"].readIcon,
        style: {
          border: "3px solid ".concat(colorToUse),
          backgroundColor: colorToUse
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: isMobile ? _UserInfo["default"].innerReadIcon : null,
        src: require('./assets/read_white.svg')
      })) : /*#__PURE__*/_react["default"].createElement("div", {
        className: isMobile ? _UserInfo["default"].unreadIconMobile : _UserInfo["default"].unreadIcon,
        style: {
          border: "3px solid ".concat(colorToUse)
        }
      }))), this.state.openSpoc === content.id && lectures.map(function (lecture) {
        return _this5.renderLecture(_this5.state.content[lecture], path);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var name = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.FEATURES, ".").concat(_config["default"].requiredFeature, ".additionalData.nickName")) ? _DataStore["default"].getElementByPathImmediately("".concat(_DataStore.DATA_STORE_PATHS.FEATURES, ".").concat(_config["default"].requiredFeature, ".additionalData.nickName")) : null;

      if (this.state.data[_DataStore.DATA_STORE_PATHS.FEATURES] && this.state.data[_DataStore.DATA_STORE_PATHS.FEATURES][_config["default"].requiredFeature] && this.state.data[_DataStore.DATA_STORE_PATHS.FEATURES][_config["default"].requiredFeature].additionalData && this.state.data[_DataStore.DATA_STORE_PATHS.FEATURES][_config["default"].requiredFeature].additionalData.firstname && this.state.data[_DataStore.DATA_STORE_PATHS.FEATURES][_config["default"].requiredFeature].additionalData.lastname) {
        var additionalData = this.state.data[_DataStore.DATA_STORE_PATHS.FEATURES][_config["default"].requiredFeature].additionalData;
        name = "".concat(additionalData.firstname, " ").concat(additionalData.lastname);
      }

      var content = [];

      if (!this.state.topLevelIds || this.state.topLevelIds.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _UserInfo["default"].userInfoContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            textAlign: 'center',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            paddingBottom: '20px'
          }
        }, "Fortschritt wird berechnet..."), /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null)));
      }

      this.state.topLevelIds.forEach(function (id) {
        content.push(_this6.state.content[id]);
      });
      var sortedContent = this.sortContents(content, this.state.topLevelContentType);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].userInfoContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          maxWidth: 'var(--app-maxWidth)',
          margin: 'auto'
        }
      }, _config["default"].showUserProfileInUserInfo && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].userDataTitle
      }, "Userdaten"), /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        className: _UserInfo["default"].userDataContainer
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], null, this.renderUserData()))), _config["default"].showSettingsInUserProfile ? /*#__PURE__*/_react["default"].createElement(_SettingsCordova["default"], {
        isEmbedded: true,
        updateContent: this.props.updateContent
      }) : null, _config["default"].showBookedCoursesInUserInfo && /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].bookedCoursesContainer
      }, /*#__PURE__*/_react["default"].createElement("div", null, this.renderBookedCourses())), _config["default"].showLearningStateInUserInfo && /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].list
      }, name ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].userText
      }, (0, _strings.getString)('WELCOME_USER', [name])) : null, _config["default"].hasCertificate && this.state.allContentDone ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].userTextSmall,
        dangerouslySetInnerHTML: {
          __html: (0, _strings.getString)('USER_INFO_ALL_DONE')
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: '20px 0'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          _this6.getPdf();
        }
      }, (0, _strings.getString)('DOWNLOAD_CERTIFICATE')))) : null, _config["default"].certificates && _config["default"].certificates.length > 0 ? this.renderCerts() : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].userTextSmall,
        style: {
          paddingBottom: '40px'
        }
      }, (0, _strings.getString)('LEARN_PROGRESS')), /*#__PURE__*/_react["default"].createElement("div", {
        key: 'title',
        className: _UserInfo["default"].titleSublist
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].listTitle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].imageColumn
      }, "\xA0"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].titleColumn
      }, (0, _strings.getString)('COURSE_TITLE')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserInfo["default"].titleReadColumn
      }))), /*#__PURE__*/_react["default"].createElement("hr", null), this.state.topLevelContentType === _Constants.CONTENT_TYPES.COURSE && sortedContent.map(function (course) {
        return _this6.renderCourse(course);
      }), this.state.topLevelContentType === _Constants.CONTENT_TYPES.SPOC && sortedContent.map(function (spoc) {
        return _this6.renderSpoc(spoc);
      }), this.state.topLevelContentType === _Constants.CONTENT_TYPES.LECTURE && sortedContent.map(function (lecture) {
        return _this6.renderLecture(lecture);
      }))));
    }
  }]);
  return UserInfo;
}(_DataStoreComponent2["default"]);

UserInfo.propTypes = {
  setTitle: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func,
  updateContent: _propTypes["default"].func
};
var _default = UserInfo;
exports["default"] = _default;